import { deliveryDetailsMsg, t } from '../../../../common/i18n/index.js';
import { OpenFormGridCol, OpenFormGridRow } from '../../OpenFormComponents/OpenFormGrid.js';
import { OpenFormItem } from '../../OpenFormComponents/OpenFormItem.js';
import { type OpenFormSummary } from '../../OpenFormHooks/useOpenFormSummary.js';
import { concat } from '../../OpenFormUtils.js';

export const OpenFormSummaryDeliveryDateTime = ({
  summary: { deliveryDate, deliveryTime },
}: {
  summary: OpenFormSummary;
}) =>
  !deliveryDate && !deliveryTime ? null : (
    <OpenFormGridRow>
      <OpenFormGridCol colWidth={9}>
        <h4>{t.GLO4(deliveryDetailsMsg)}</h4>
        <OpenFormGridRow>
          <OpenFormGridCol>
            <OpenFormItem>{concat(deliveryDate, deliveryTime).join(' ')}</OpenFormItem>
          </OpenFormGridCol>
        </OpenFormGridRow>
        <hr />
      </OpenFormGridCol>
    </OpenFormGridRow>
  );
